import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
import { INTERNAL_DATE_FORMAT } from '../../../../../constants'
import { disableHolidaysAndWeekends } from '../../../../../utils'
import CellDownload from './CellDownload'
import CellSettingsMenu from './CellSettingsMenu'
import CellReportStatus from './CellReportStatus'

dayjs.extend(utc)

export const FREQUENCY_OPTIONS = [
  { tagName: 'Quarterly', id: 'Q' },
  { tagName: 'Annual', id: 'A' },
  { tagName: 'Monthly', id: 'M' }
]

export const CLIENT_LEVEL_VALUE = 'select_client'
export const ACCOUNT_LEVEL_VALUE = 'select_account'

export const LEVEL_OPTIONS = [
  { tagName: 'All Clients', id: 'client' },
  { tagName: 'All Accounts', id: 'account' },
  { tagName: 'Select Client(s)', id: CLIENT_LEVEL_VALUE },
  { tagName: 'Select Account(s)', id: ACCOUNT_LEVEL_VALUE }
]

export const columnsConfig = {
  columns: [
    { Header: 'Billing Run ID', accessor: 'billingRunId' },
    { Header: 'Run Date', accessor: 'createdAt' },
    { Header: 'Level', accessor: 'levelType' },
    { Header: 'As of Date', accessor: 'asOfDate' },
    { Header: 'Start Date', accessor: 'startDate' },
    { Header: 'End Date', accessor: 'endDate' },
    { Header: 'Frequency', accessor: 'frequency' },
    {
      Header: 'Report Status',
      Cell: CellReportStatus
    },
    {
      Header: 'Run By',
      accessor: (row) => {
        return `${row.runBy.firstName} ${row.runBy.lastName}`
      }
    },
    {
      Header: 'Download',
      Cell: CellDownload
    },
    {
      Header: 'Options',
      Cell: CellSettingsMenu
    }
  ],
  defaultSort: []
}

export const RUN_STATUS = {
  ARCHIVED: 'ARCHIVED',
  ACTIVE: 'ACTIVE',
  IN_REVIEW: 'IN_REVIEW',
  MARK_AS_FINAL: 'MARK_AS_FINAL'
}

export const RUN_DISPLAY_STATUS = {
  ARCHIVED: 'Archived',
  PENDING: 'Pending',
  ACTIVE: 'Completed',
  IN_REVIEW: 'In Review',
  MARK_AS_FINAL: 'Marked as Final'
}

export const REPORT_STATUS = {
  PROCESSED: 'PROCESSED',
  PROCESSING: 'PROCESSING',
  PROCESSING_EXPIRED: 'PROCESSING_EXPIRED',
  GENERATING_EXPORTS: 'GENERATING_EXPORTS',
  ERROR: 'ERROR'
}

export const RUN_REPORT_DISPLAY_STATUS = {
  PROCESSED: 'Processed',
  PROCESSING: 'Processing',
  PROCESSING_EXPIRED: 'Report Processing Expired',
  GENERATING_EXPORTS: 'Generating Exports',
  ERROR: 'Error'
}

export const RUN_STATUS_LABELS = {
  ARCHIVED: 'Archive',
  MARK_AS_FINAL: 'Mark as Final',
  IN_REVIEW: 'Move to In Review'
}

const MONTHLY = 'M'
const QUARTERLY = 'Q'
const ANNUAL = 'A'

export const getNearestWorkableAsOfDate = (holidays, defaultAsOfDate, searchBackwards = true) => {
  if (!holidays || !defaultAsOfDate) return null

  let date = dayjs.isDayjs(defaultAsOfDate)
    ? defaultAsOfDate
    : dayjs.utc(defaultAsOfDate)

  let isHolidayOrWeekend = true
  do {
    isHolidayOrWeekend = disableHolidaysAndWeekends(date, holidays, false)
    if (isHolidayOrWeekend) {
      date = searchBackwards
        ? date.subtract(1, 'day')
        : date.add(1, 'day')
      continue
    }
    isHolidayOrWeekend = false
  } while (isHolidayOrWeekend)

  return date.format(INTERNAL_DATE_FORMAT)
}

export function getPayloadDates (asOfDate, frequency) {
  const date = dayjs.utc(asOfDate)
  const endDate = date

  const isMonthly = frequency === MONTHLY
  const isQuarterly = frequency === QUARTERLY
  const isYearly = frequency === ANNUAL

  const unit =
    (isMonthly && 'month') ||
    (isQuarterly && 'quarter') ||
    (isYearly && 'year')

  const startDate = endDate.startOf(unit)

  return {
    startDate: startDate.format(INTERNAL_DATE_FORMAT),
    endDate: endDate.format(INTERNAL_DATE_FORMAT)
  }
}

export const REPORT_TYPES = {
  CASH_AVAILABLE_REPORT: 'CASH_AVAILABLE_REPORT'
}

export const REPORT_TYPE_NAMES = {
  [REPORT_TYPES.CASH_AVAILABLE_REPORT]: 'Cash Available'
}

export const BILLING_RUNS_CONTEXT_KEY = 'BILLING_RUNS_CONTEXT_KEY'
